module.exports = __webpack_public_path__ + "fonts/ReadexPro-SemiBold.88de789.ttf";